var _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBells(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bell_2_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bell_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape_11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#EDD67F",
    d: "M384.224,232.065c-39.207-19.124-64.042-78.112-109.582-86.411 c-24.923-4.572-43.262,5.963-60.227,21.006c-17.986,13.844-31.749,29.849-31.994,55.199 c-0.437,46.319,52.836,81.762,64.222,123.9c7.232,26.74,6.52,58.306-17.241,80.789c111.446-56.12,161.326-97.362,237.43-196.239 C440.28,249.434,409.12,244.216,384.224,232.065z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shape_12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#DEBA5B",
    d: "M473.001,221.289 c-65.657,87.219-151.26,157.904-249.247,206.004c12.763,15.423,19.16,23.153,31.906,38.588 c98.013-48.074,183.578-118.784,249.235-205.99C492.136,244.456,485.77,236.726,473.001,221.289z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shape_13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#8A5715",
    d: "M429.604,349.126c-0.683-0.771-1.454-1.401-2.158-2.147 c-24.709,23.241-37.769,34.104-65.115,54.149c0.592,0.848,1.023,1.757,1.679,2.565c14.907,18.037,42.504,21.485,60.631,6.416 C442.78,395.003,444.511,367.176,429.604,349.126z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Bell_copy_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape_11_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFDA58",
    d: "M190.019,306.749c-2.694-29.229,22.584-64.051,11.458-93.146 c-6.093-15.923-18.518-22.787-33.099-27.301c-14.218-5.509-28.246-7.854-42.885,0.867c-26.763,15.899-28.6,58.901-48.834,80.141 c-12.848,13.492-31.268,24.081-52.484,18.245c71.136,44.501,112.24,58.813,195.638,68.083 C199.568,345.03,191.725,325.3,190.019,306.749z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shape_12_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E5BA26",
    d: "M18.172,281.313C13.74,294.035,11.537,300.4,7.11,313.118 c61.817,39.592,132.319,64.12,205.364,71.464c4.419-12.715,6.64-19.087,11.073-31.798 C150.512,345.417,79.992,320.913,18.172,281.313z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shape_13_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#8A5715",
    d: "M76.333,349.873c-0.27,0.635-0.608,1.213-0.857,1.858 c-5.168,14.87,2.441,32.006,17.415,37.279c14.957,5.253,31.545-3.386,36.716-18.248c0.224-0.662,0.282-1.337,0.457-2.01 C108.13,362.523,97.353,358.734,76.333,349.873z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Bell_copy_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape_11_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFDA58",
    d: "M384.224,232.065c-39.207-19.124-64.042-78.112-109.582-86.411 c-24.923-4.572-43.262,5.963-60.227,21.006c-17.986,13.844-31.749,29.849-31.994,55.199 c-0.437,46.319,52.836,81.762,64.222,123.9c7.232,26.74,6.52,58.306-17.241,80.789c111.446-56.12,161.326-97.362,237.43-196.239 C440.28,249.434,409.12,244.216,384.224,232.065z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shape_12_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E5BA26",
    d: "M473.001,221.289 c-65.657,87.219-151.26,157.904-249.247,206.004c12.763,15.423,19.16,23.153,31.906,38.588 c98.013-48.074,183.578-118.784,249.235-205.99C492.136,244.456,485.77,236.726,473.001,221.289z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shape_13_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#8A5715",
    d: "M429.604,349.126c-0.683-0.771-1.454-1.401-2.158-2.147 c-24.709,23.241-37.769,34.104-65.115,54.149c0.592,0.848,1.023,1.757,1.679,2.565c14.907,18.037,42.504,21.485,60.631,6.416 C442.78,395.003,444.511,367.176,429.604,349.126z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Ribbon_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape_15"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DF4B4B",
    d: "M338.778,108.372c-40.2-3.386-73.822,18.972-111.945,26.146c24.89-13.161,47.394-38.108,73.402-52.608 c-20.104-20.45-51.335-39.776-76.825-52.483c-9.501,28.326-27.83,75.191-18.934,106l-77.839-37.727L108.92,172.54l74.875-8.615 l-62.646,23.948l37.399,39.284l60.409-62.917c28.842-3.924,75.638-2.534,105.067,0.871 c-11.178-9.549-22.478-20.652-33.705-30.428C306.027,125.893,322.043,115.016,338.778,108.372z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shape_16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#A24646",
    points: "146.038,132.373 137.917,146.001 212.061,148.642  "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBells);
export default __webpack_public_path__ + "static/media/bells.2cc0293a.svg";
export { ForwardRef as ReactComponent };